<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-check"></i> {{ "TITLE.DOCUMENT" | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col" class="custom-col-1">#</th>
          <th scope="col" class="custom-col-2">{{ "TABLE.HEADER.ENTERPRISE" | translate }}</th>
          <th scope="col" class="custom-col-3">{{ "TABLE.HEADER.ACTION" | translate }}</th>
          <th scope="col" class="custom-col-4">{{ "TABLE.HEADER.PERSON" | translate }}</th>
          <th scope="col" class="custom-col-5">{{ "TABLE.HEADER.STATE" | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let person of people; let index = index;">
          <td class="font-weight-bold" title="#">
            {{index + 1}}
          </td>
          <td class="" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}">
            {{person.enterpriseName}}
          </td>
          <td class="" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
          <span class="badge {{isSigner(person)?'badge-success':'badge-warning'}}">
          {{getOperationDescription(person) | translate}}
          </span>
          </td>
          <td class="" title="{{ 'TABLE.HEADER.PERSON' | translate }}">
            {{person.fullname | translate}}
          </td>
          <td class="" title="{{ 'TABLE.HEADER.STATE' | translate }}">
          <span class="badge {{isOperationComplete(person)?'badge-success':'badge-primary'}}">
          {{isOperationComplete(person) ? ('MESSAGE.COMPLETED' | translate) : ('MESSAGE.NOT-COMPLETED' | translate) }}
          </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success"
            [disabled]="isThereSomeOperationCompleted"
            (click)="finalizeDocument()">
      <i class="fas fa-flag-checkered"></i> {{ "BUTTON.FINALIZE" | translate }}
    </button>
    <button type="button"
            class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fas fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
